export const required = value => (value ? undefined : 'Necessario')
export const email = value =>
  value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
    ? 'Indirizzo email non valido'
    : undefined
export const number = value =>
  value && isNaN(Number(value)) ? 'Deve essere un numero' : undefined
export const maxLength = max => value =>
  value && value.length > max ? `Deve essere di ${max} caratteri o meno` : undefined
export const minLength = min => value =>
  value && value.length < min ? `Deve essere di ${min} caratteri o più` : undefined



// WEBPACK FOOTER //
// ./src/utils/validators.js